// extracted by mini-css-extract-plugin
export default {"soonTitle":"products_soonTitle__FFgMV","products":"products_products__6kCwI"};